import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pop_audio : false,
  pop_video : false,
  pop_card : false,
  pop_game : false,
  fullscreen : false,
  zoom : 0,
  loading : false,
  tab : 0,
};

const common = createSlice({
  name : 'common',
  initialState,
  reducers : {
    closePop(state, action) {
      state.pop_audio = false;
      state.pop_video = false;
      state.pop_card = false;
      state.pop_game = false;
    },
    setPopAudio(state, action) {
      state.pop_audio = action.payload;
    },
    setPopVideo(state, action) {
      state.pop_video = action.payload;
    },
    setPopCard(state, action) {
      state.pop_card = action.payload;
    },
    setPopGame(state, action) {
      state.pop_game = action.payload;
    },
    setFullscreen(state, action) {
      state.fullscreen = action.payload;
    },
    setZoom(state, action) {
      state.zoom = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setTab(state, action) {
      state.tab = action.payload;
    }
  }
});

export const {closePop, setPopAudio, setPopVideo, setPopCard, setPopGame, setFullscreen, setZoom, setLoading, setTab} = common.actions;

export default common;